<template>
    <div>
        <table class="w-100">
            <tr v-for="(value, attribute) in filteredScores" :key="attribute">
                <td :class="[`align-middle low-title text-nowrap text-center pr-3 pb-2`, {'text-primary': value.score < 5}]">{{ value.lowTitle }}</td>
                <td class="w-100 pb-2">
                    <div class="slider">
                        <div class="bar"></div>
                        <div class="thumb" :style="`left: calc(${percentageForScore(value.score)}% - 8px)`" :title="`${percentageForScore(value.score)}%`"></div>
                    </div>
                </td>
                <td :class="[`align-middle high-title text-nowrap text-center pl-3 pb-2`, {'text-primary': value.score >= 5}]">{{ value.highTitle }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
Object.filter = (obj, predicate) => 
    Object.keys(obj)
          .filter( key => predicate(obj[key]) )
          .reduce( (res, key) => (res[key] = obj[key], res), {} );
          
export default {
    name: 'EnvironmentalAttributes',
    props: {
        attributes: {
            type: Object,
            required: true,
        },
    },
    methods: {
        percentageForScore(score) {
            return score / 10 * 100;
        },
    },
    computed: {
        filteredScores() {
            return Object.filter(this.scores, score => score.score != null)
        },
        scores() {
            return {
                'cleanliness': {
                    score: this.attributes.cleanliness,
                    lowTitle: 'Dirty',
                    highTitle: 'Clean',
                },
                'comfort': {
                    score: this.attributes.comfort,
                    lowTitle: 'Uncomfortable',
                    highTitle: 'Comfortable',
                },
                'calmness': {
                    score: this.attributes.calmness,
                    lowTitle: 'Energetic',
                    highTitle: 'Calm',
                },
                'development': {
                    score: this.attributes.development,
                    lowTitle: 'Undeveloped',
                    highTitle: 'Developed',
                },
                'nudity_level': {
                    score: this.attributes.nudity_level,
                    lowTitle: 'More Clothed',
                    highTitle: 'More Naked',
                },
            }
        }
    }
};
</script>

<style scoped lang="scss">
.slider {
    position: relative;
    
    .bar {
        position: absolute;
        height: 4px;
        background: $light-gray;
        top: 50%;
        left: 0;
        right: 0;
        border-radius: 4px;
        transform: translateY(-50%);
    }
    .thumb {
        position: absolute;
        width: 15px;
        height: 15px;
        background: $primary;
        border-radius: 15px;
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>